import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "new-cashfloat-close",
  style: {
    "width": "100%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "background-color": "white"
  }
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "space-between",
    "justify-content": "center",
    "height": "100%"
  }
};
var _hoisted_3 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "width": "28%",
    "padding-top": "15px"
  }
};
var _hoisted_4 = {
  style: {
    "margin-bottom": "7%",
    "padding-bottom": "5%",
    "text-align": "center",
    "border-bottom": "1px solid #d1d1d1"
  }
};
var _hoisted_5 = {
  style: {
    "font-size": "15px"
  }
};
var _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-start",
    "border-bottom": "1px solid #d1d1d1",
    "padding": "3%",
    "padding-bottom": "5%"
  }
};
var _hoisted_7 = {
  style: {
    "width": "10%",
    "height": "100%",
    "text-align": "center"
  }
};
var _hoisted_8 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-evenly",
    "width": "85%"
  }
};
var _hoisted_9 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "4%"
  }
};
var _hoisted_10 = {
  style: {
    "text-align": "left"
  }
};
var _hoisted_11 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_12 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_13 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_14 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_15 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_16 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_17 = {
  key: 0
};
var _hoisted_18 = {
  key: 1
};
var _hoisted_19 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_20 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_21 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_22 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_23 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_24 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_25 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_26 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_27 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_28 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-bottom": "2px",
    "margin-top": "2px"
  }
};
var _hoisted_29 = {
  style: {
    "text-align": "left",
    "color": "gray"
  }
};
var _hoisted_30 = {
  style: {
    "text-align": "right"
  }
};
var _hoisted_31 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "flex-wrap": "wrap",
    "margin-bottom": "2px",
    "margin-top": "7px"
  }
};
var _hoisted_32 = ["onClick"];
var _hoisted_33 = {
  style: {
    "text-align": "right",
    "width": "45%"
  }
};
var _hoisted_34 = {
  style: {
    "white-space": "nowrap",
    "width": "100%",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
var _hoisted_35 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_36 = {
  class: "dialog-footer"
};
var _hoisted_37 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "width": "72%",
    "border-left": "2px solid #d1d1d1",
    "padding": "1%",
    "padding-top": "15px"
  }
};
var _hoisted_38 = {
  style: {
    "font-size": "24px"
  }
};
var _hoisted_39 = {
  key: 0
};
var _hoisted_40 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-start",
    "margin-top": "2%"
  }
};
var _hoisted_41 = {
  style: {
    "text-align": "left",
    "margin-right": "10px",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_42 = {
  key: 0,
  style: {
    "color": "red",
    "font-size": "14px",
    "margin-top": "-5px"
  }
};
var _hoisted_43 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "width": "100%",
    "margin-bottom": "2%",
    "margin-top": "3%"
  }
};
var _hoisted_44 = {
  style: {
    "border": "1px solid #d1d1d1",
    "border-radius": "5px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "width": "30%",
    "height": "120px",
    "padding-bottom": "0.5%",
    "padding-top": "0.5%",
    "box-shadow": "0px 5px 4px #d1d1d1"
  }
};
var _hoisted_45 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between"
  }
};

var _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "center",
    "width": "30px",
    "height": "30px",
    "line-height": "30px",
    "border-radius": "50%",
    "background-color": "#044c55",
    "color": "white"
  }
}, [/*#__PURE__*/_createElementVNode("strong", null, "I")])], -1);

var _hoisted_47 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_48 = {
  style: {
    "font-size": "15px",
    "color": "gray"
  }
};
var _hoisted_49 = {
  style: {
    "text-align": "center",
    "height": "38%"
  }
};
var _hoisted_50 = {
  style: {
    "font-size": "20px"
  }
};
var _hoisted_51 = {
  style: {
    "border": "1px solid #d1d1d1",
    "border-radius": "5px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "width": "30%",
    "height": "120px",
    "padding-bottom": "0.5%",
    "padding-top": "0.5%",
    "box-shadow": "0px 5px 4px #d1d1d1"
  }
};
var _hoisted_52 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "width": "100%"
  }
};
var _hoisted_53 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "align-items": "center"
  }
};
var _hoisted_54 = {
  style: {
    "width": "50%",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};

var _hoisted_55 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin-left": "-15px",
    "text-align": "center",
    "width": "30px",
    "height": "30px",
    "line-height": "30px",
    "border-radius": "50%",
    "background-color": "#044c55",
    "color": "white"
  }
}, [/*#__PURE__*/_createElementVNode("strong", null, "F")], -1);

var _hoisted_56 = {
  style: {
    "cursor": "pointer",
    "margin-right": "10px"
  }
};
var _hoisted_57 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_58 = {
  style: {
    "font-size": "15px",
    "color": "gray"
  }
};
var _hoisted_59 = {
  style: {
    "text-align": "center",
    "height": "38%"
  }
};
var _hoisted_60 = {
  style: {
    "border": "1px solid #d1d1d1",
    "border-radius": "5px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "width": "30%",
    "height": "120px",
    "padding-bottom": "0.5%",
    "padding-top": "0.5%",
    "box-shadow": "0px 5px 4px #d1d1d1"
  }
};
var _hoisted_61 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "width": "100%"
  }
};
var _hoisted_62 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "align-items": "center"
  }
};
var _hoisted_63 = {
  style: {
    "width": "50%",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "align-items": "center"
  }
};

var _hoisted_64 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "center",
    "width": "30px",
    "height": "30px",
    "line-height": "30px",
    "border-radius": "50%",
    "background-color": "#044c55",
    "color": "white"
  }
}, [/*#__PURE__*/_createElementVNode("strong", null, "D")], -1);

var _hoisted_65 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_66 = {
  style: {
    "font-size": "15px",
    "color": "gray"
  }
};
var _hoisted_67 = {
  style: {
    "text-align": "center",
    "height": "38%"
  }
};
var _hoisted_68 = {
  style: {
    "font-size": "20px"
  }
};

var _hoisted_69 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border-bottom": "1px solid #d1d1d1",
    "width": "100%",
    "margin-bottom": "2%",
    "margin-top": "2%"
  }
}, null, -1);

var _hoisted_70 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "width": "100%",
    "margin-bottom": "2%",
    "margin-top": "2%"
  }
};
var _hoisted_71 = {
  key: 0,
  style: {
    "border": "1px solid #d1d1d1",
    "border-radius": "5px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "width": "30%",
    "height": "120px",
    "padding-bottom": "0.5%",
    "padding-top": "0.5%",
    "box-shadow": "0px 5px 4px #d1d1d1"
  }
};

var _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center"
  }
}, [/*#__PURE__*/_createElementVNode("p", null, "$")], -1);

var _hoisted_73 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "20px"
  }
}, "Cash in/out")], -1);

var _hoisted_74 = [_hoisted_72, _hoisted_73];
var _hoisted_75 = {
  style: {
    "border": "1px solid #d1d1d1",
    "border-radius": "5px",
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "width": "30%",
    "height": "120px",
    "padding-bottom": "0.5%",
    "padding-top": "0.5%",
    "box-shadow": "0px 5px 4px #d1d1d1"
  }
};
var _hoisted_76 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_77 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_78 = {
  style: {
    "font-size": "20px"
  }
};

var _hoisted_79 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "border-bottom": "1px solid #d1d1d1",
    "width": "100%",
    "margin-bottom": "2%",
    "margin-top": "2%"
  }
}, null, -1);

var _hoisted_80 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-start",
    "width": "100%",
    "margin-bottom": "2%",
    "margin-top": "2%"
  }
};
var _hoisted_81 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "padding": "5%"
  }
};

var _hoisted_82 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "20px"
  }
}, [/*#__PURE__*/_createElementVNode("strong", null, "X")])], -1);

var _hoisted_83 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_84 = {
  style: {
    "font-size": "20px"
  }
};
var _hoisted_85 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    "padding": "5%"
  }
};
var _hoisted_86 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_87 = {
  style: {
    "text-align": "center"
  }
};
var _hoisted_88 = {
  style: {
    "font-size": "20px"
  }
};
var _hoisted_89 = {
  key: 0,
  class: "cancel-tickets-popup"
};
var _hoisted_90 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-self": "center"
  }
};
var _hoisted_91 = {
  style: {
    "height": "54vh",
    "overflow-y": "scroll",
    "border-radius": "6px",
    "border": "1px solid #a6a6a6"
  },
  ref: "cashDetailsArea"
};
var _hoisted_92 = {
  style: {
    "font-size": "35px"
  }
};
var _hoisted_93 = {
  style: {
    "margin-top": "2%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_94 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_95 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_96 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_97 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_98 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_99 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_100 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};

var _hoisted_101 = /*#__PURE__*/_createElementVNode("hr", null, null, -1);

var _hoisted_102 = {
  style: {
    "margin-top": "3%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_103 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_104 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_105 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_106 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_107 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_108 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_109 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_110 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_111 = {
  style: {
    "color": "#ededed"
  }
};
var _hoisted_112 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_113 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_114 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "padding-top": "1.5%",
    "padding-bottom": "2.5%"
  }
};
var _hoisted_115 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "border-top": "1px solid gray",
    "margin-top": "3%",
    "padding-top": "1.5%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_input_number = _resolveComponent("el-input-number");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(String(_ctx.t("cashfloat.check-selling-period")).replace("xxx", _ctx.userFirstName)), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, function (currency, index) {
    return _openBlock(), _createElementBlock("div", {
      style: {
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "flex-start",
        "border-bottom": "1px solid #d1d1d1",
        "padding": "3%",
        "padding-bottom": "5%"
      },
      key: index
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      style: _normalizeStyle([{
        "height": "30px",
        "width": "30px",
        "line-height": "30px",
        "border-radius": "50%",
        "background-color": "#00a1c0",
        "color": "white",
        "font-size": "11px"
      }, _ctx.groupCurrencySymbol.length === 1 ? 'font-size:15px' : 'font-size:11px'])
    }, [_createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol(currency.label)), 1)], 4)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("multicurrencies.cash-in")) + " " + _toDisplayString(currency.label), 1)])]), _createElementVNode("div", {
      style: _normalizeStyle([{
        "text-align": "right",
        "padding-left": "8px",
        "padding-right": "8px",
        "border-radius": "8px",
        "font-size": "12px",
        "line-height": "30px",
        "height": "30px"
      }, Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label]) === 0 ? 'background-color: rgba(28, 138, 147, 0.3);color: green;' : 'background-color: rgba(255, 0, 0, 0.2);color: red;'])
    }, [_createElementVNode("p", null, _toDisplayString(Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label]) === 0 ? _ctx.t("cashfloat.matched") : _ctx.t("cashfloat.unmatched")), 1)], 4)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.initial-cashfloat")), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + Number(_ctx.cashFloatStartAmounts[currency.label]).toFixed(2)), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.cash-income-and-entries")), 1)]), _createElementVNode("div", _hoisted_16, [currency.label === _ctx.groupCurrency ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + ((_ctx.totalCashSalesByCurrency[currency.label] || 0) + _ctx.getSumOfCashIn).toFixed(2)), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + (_ctx.totalCashSalesByCurrency[currency.label] || 0).toFixed(2)), 1))])]), currency.label === _ctx.groupCurrency ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.outflow-and-withdrawal")), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("p", null, _toDisplayString(_ctx.groupCurrencySymbol + " " + _ctx.getSumOfCashOut.toFixed(2)), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.expected-amount")), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + Number(_ctx.expectedCashfloats[currency.label]).toFixed(2)), 1)])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.counted-amount")), 1)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + Number(_ctx.finalManualCashfloats[currency.label]).toFixed(2)), 1)])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.difference")), 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + (Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label])).toFixed(2)), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
      style: {
        "text-align": "left",
        "color": "#00a1c0",
        "cursor": "pointer",
        "width": "45%"
      },
      onClick: function onClick($event) {
        return _ctx.showCashNoteDialog(currency);
      }
    }, [_createElementVNode("p", {
      ref_for: true,
      ref: "add-note-".concat(currency.label)
    }, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.add-note")), 1)], 512)], 8, _hoisted_32), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.cashNotes[currency.label]), 1)])])])])]);
  }), 128)), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.cashNoteDialogVisibility,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.cashNoteDialogVisibility = $event;
    }),
    title: _ctx.t('cashfloat.add-note'),
    width: "30%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_36, [_createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          var _ctx$cashNoteCurrency;

          _ctx.cashNotes[((_ctx$cashNoteCurrency = _ctx.cashNoteCurrency) === null || _ctx$cashNoteCurrency === void 0 ? void 0 : _ctx$cashNoteCurrency.label) || _ctx.groupCurrency] = '';
          _ctx.cashNoteDialogVisibility = false;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.t("button.cancel")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.cashNoteDialogVisibility = false;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.t("button.confirm")), 1)];
        }),
        _: 1
      })])];
    }),
    default: _withCtx(function () {
      var _ctx$cashNoteCurrency2;

      return [_createElementVNode("div", null, [_createVNode(_component_el_input, {
        modelValue: _ctx.cashNotes[((_ctx$cashNoteCurrency2 = _ctx.cashNoteCurrency) === null || _ctx$cashNoteCurrency2 === void 0 ? void 0 : _ctx$cashNoteCurrency2.label) || _ctx.groupCurrency],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          var _ctx$cashNoteCurrency3;

          return _ctx.cashNotes[((_ctx$cashNoteCurrency3 = _ctx.cashNoteCurrency) === null || _ctx$cashNoteCurrency3 === void 0 ? void 0 : _ctx$cashNoteCurrency3.label) || _ctx.groupCurrency] = $event;
        }),
        rows: 3,
        type: "textarea",
        placeholder: _ctx.t('cashfloat.write-your-note-here')
      }, null, 8, ["modelValue", "placeholder"])])];
    }),
    _: 1
  }, 8, ["modelValue", "title"])])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_38, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.cashfloat")), 1)])]), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.cash-intended-to")) + ":", 1)]), _createElementVNode("div", null, [_createVNode(_component_el_select, {
    modelValue: _ctx.locationId,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.locationId = $event;
    }),
    placeholder: _ctx.$t('location'),
    disabled: _ctx.willMoneyStayInDrawer
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: Number(item.id),
          label: String(item.name),
          value: Number(item.id)
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "placeholder", "disabled"])])]), _createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
    modelValue: _ctx.willMoneyStayInDrawer,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return _ctx.willMoneyStayInDrawer = $event;
    }),
    label: _ctx.$t('cashfloat.money-stays-in-the-drawer'),
    size: "large",
    onChange: _ctx.resetLocationId
  }, null, 8, ["modelValue", "label", "onChange"]), _ctx.showErrorMsg && !_ctx.locationId && !_ctx.willMoneyStayInDrawer ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.t("cashfloat.please-select-money-destination")), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, function (currency, index) {
    return _openBlock(), _createElementBlock("div", {
      style: {
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
        "height": "100%",
        "margin-bottom": "2%",
        "margin-top": "3%"
      },
      key: index
    }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, [_createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.t("cashfloat.initial-cashfloat")), 1)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("p", _hoisted_50, [_createElementVNode("strong", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + Number(_ctx.cashFloatStartAmounts[currency.label]).toFixed(2)), 1)])])])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_button, {
      onClick: function onClick($event) {
        return _ctx.displayCoinsAndBillsDialog(currency.label);
      },
      "input-style": "cursor: pointer;margin-right:10px;background-color: rgba(28, 138, 147, 0.3);color: green; height:40px; width:40px; border-radius:50%;line-height:40px;text-align:center",
      icon: _ctx.EditIcon,
      circle: ""
    }, null, 8, ["onClick", "icon"])])])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.t("cashfloat.final-cashfloat")), 1)]), _createElementVNode("div", _hoisted_59, [_createVNode(_component_el_input_number, {
      modelValue: _ctx.finalManualCashfloats[currency.label],
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.finalManualCashfloats[currency.label] = $event;
      },
      precision: 2,
      min: 0,
      "controls-position": "right",
      size: "large",
      "input-style": "text-align:center; font-size:20px;font-weight:bolder;color:unset; width:50%; margin-left:auto;margin-right:auto"
    }, null, 8, ["modelValue", "onUpdate:modelValue"])])])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_hoisted_64, _createElementVNode("div", null, [_createElementVNode("div", {
      style: _normalizeStyle([{
        "margin-left": "-15px",
        "margin-right": "5px",
        "text-align": "right",
        "padding-left": "8px",
        "padding-right": "8px",
        "border-radius": "8px",
        "font-size": "12px",
        "line-height": "30px",
        "height": "30px"
      }, Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label]) === 0 ? 'background-color: rgba(28, 138, 147, 0.3);color: green;' : 'background-color: rgba(255, 0, 0, 0.2);color: red;'])
    }, [_createElementVNode("p", null, _toDisplayString(Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label]) === 0 ? _ctx.t("cashfloat.matched") : _ctx.t("cashfloat.unmatched")), 1)], 4)])])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.t("cashfloat.difference")), 1)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("p", _hoisted_68, [_createElementVNode("strong", null, _toDisplayString(_ctx.currencySymbol(currency.label) + " " + (Number(_ctx.finalManualCashfloats[currency.label]) - Number(_ctx.expectedCashfloats[currency.label])).toFixed(2)
    /*differenceValue.toFixed(2)*/
    ), 1)])])])])])]);
  }), 128)), _hoisted_69, _createElementVNode("div", _hoisted_70, [_ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "space-between",
      "padding": "5%"
    },
    onClick: _cache[6] || (_cache[6] = function ($event) {
      return _ctx.toggleModalVisible(_ctx.ModalStatus.CashInOut);
    })
  }, _hoisted_74)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "space-between",
      "padding": "5%"
    },
    onClick: _cache[7] || (_cache[7] = //@ts-ignore
    function () {
      return _ctx.openDrawer && _ctx.openDrawer.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_76, [_createElementVNode("p", null, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.drawerIconContent,
    iconAlt: _ctx.drawerIconAlt,
    iconStyle: _ctx.drawerIconStyle
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])]), _createElementVNode("div", _hoisted_77, [_createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.t("button.open-drawer")), 1)])])])]), _hoisted_79, _createElementVNode("div", _hoisted_80, [_createElementVNode("div", {
    onClick: _cache[8] || (_cache[8] = //@ts-ignore
    function () {
      return _ctx.cancel && _ctx.cancel.apply(_ctx, arguments);
    }),
    style: {
      "border": "1px solid #d1d1d1",
      "border-radius": "5px",
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "center",
      "width": "30%",
      "height": "120px",
      "background-color": "red",
      "color": "white",
      "cursor": "pointer",
      "margin-left": "0%",
      "margin-right": "1.665%",
      "box-shadow": "0px 5px 4px #d1d1d1"
    }
  }, [_createElementVNode("div", _hoisted_81, [_hoisted_82, _createElementVNode("div", _hoisted_83, [_createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.t("cashfloat.cancel-return")), 1)])])]), _createElementVNode("div", {
    style: {
      "border": "1px solid #d1d1d1",
      "border-radius": "5px",
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "center",
      "width": "30%",
      "height": "120px",
      "background-color": "#00a1c0",
      "color": "white",
      "cursor": "pointer",
      "margin-left": "1.665%",
      "margin-right": "1.665%",
      "box-shadow": "0px 5px 4px #d1d1d1"
    },
    onClick: _cache[9] || (_cache[9] = function ($event) {
      return _ctx.componentCloseCashfloat();
    })
  }, [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("p", null, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.iconContent,
    iconAlt: _ctx.iconAlt,
    iconStyle: _ctx.iconStyle
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.t("cashfloat.accept-close")), 1)])])])])])])]), _ctx.showCoinsAndBillsDialog ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createVNode(_component_el_dialog, {
    title: 'Cashfloat',
    width: "50%",
    modelValue: _ctx.showCoinsAndBillsDialog,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return _ctx.showCoinsAndBillsDialog = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectedDetailedCurrency, function (curr) {
        return _openBlock(), _createElementBlock("div", {
          key: curr.id,
          style: {
            "padding": "4%"
          }
        }, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.t("cashfloat.cashfloat")) + " " + _toDisplayString(curr.detailedName), 1)]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.bills")), 1)]), _createElementVNode("div", _hoisted_96, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_97, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.bills, function (bill, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            style: {
              "display": "flex",
              "flex-direction": "row",
              "justify-content": "center",
              "align-items": "center",
              "border-bottom": "1px solid #ededed",
              "padding-bottom": "1%",
              "padding-top": "1%"
            }
          }, [_createElementVNode("div", _hoisted_98, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(bill.name), 1)])]), _createElementVNode("div", _hoisted_99, [_createVNode(_component_el_input, {
            modelValue: bill.userInput,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return bill.userInput = $event;
            },
            type: "number",
            min: 0,
            onFocus: _ctx.handleInputFocus,
            onBlur: _ctx.handleInputBlur
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_100, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(bill.name) * (bill.userInput ? bill.userInput : 0)).toLocaleString("en-EN", {
            /*style: "currency",
            currency: "en-EN",*/
            minimumFractionDigits: 2,

            /*minimumIntegerDigits: 3,*/
            maximumFractionDigits: 2
          }).split(",").join("'")), 1)])])]);
        }), 128))]), _hoisted_101, _createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.coins")), 1)]), _createElementVNode("div", _hoisted_105, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_106, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.coins, function (coin, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            style: {
              "display": "flex",
              "flex-direction": "row",
              "justify-content": "center",
              "align-items": "center",
              "border-bottom": "1px solid #ededed",
              "padding-bottom": "1%",
              "padding-top": "1%"
            }
          }, [_createElementVNode("div", _hoisted_107, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(coin.name), 1)])]), _createElementVNode("div", _hoisted_108, [_createVNode(_component_el_input, {
            modelValue: coin.userInput,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return coin.userInput = $event;
            },
            type: "number",
            min: 0,
            onFocus: _ctx.handleInputFocus,
            onBlur: _ctx.handleInputBlur
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_109, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(coin.name) * (coin.userInput ? coin.userInput : 0)).toLocaleString("en-EN", {
            /*style: "currency",
            currency: "en-EN",*/
            minimumFractionDigits: 2,

            /*minimumIntegerDigits: 3,*/
            maximumFractionDigits: 2
          }).split(",").join("'")), 1)])])]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.cents, function (cent, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            style: {
              "display": "flex",
              "flex-direction": "row",
              "justify-content": "center",
              "align-items": "center",
              "border-bottom": "1px solid #ededed",
              "padding-bottom": "1%",
              "padding-top": "1%"
            }
          }, [_createElementVNode("div", _hoisted_110, [_createElementVNode("p", null, [_createElementVNode("strong", null, [_createTextVNode(_toDisplayString(cent.name), 1), _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.t("cashfloat.cents")), 1)])])]), _createElementVNode("div", _hoisted_112, [_createVNode(_component_el_input, {
            modelValue: cent.userInput,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return cent.userInput = $event;
            },
            type: "number",
            min: 0,
            onFocus: _ctx.handleInputFocus,
            onBlur: _ctx.handleInputBlur
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_113, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(cent.name) * (cent.userInput ? cent.userInput : 0) / 100).toLocaleString("en-EN", {
            /*style: "currency",
            currency: "en-EN",*/
            minimumFractionDigits: 2,

            /*minimumIntegerDigits: 3,*/
            maximumFractionDigits: 2
          }).split(",").join("'")), 1)])])]);
        }), 128))]), _createElementVNode("div", _hoisted_114, [_createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.total-cashfloat-in") + " ") + " " + _toDisplayString(curr.label), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.sumCashByCurrency(curr.id).toLocaleString("en-EN", {
          /*style: "currency",
            currency: "en-EN",*/
          minimumFractionDigits: 2,

          /*minimumIntegerDigits: 3,*/
          maximumFractionDigits: 2
        }).split(",").join("'")), 1)])])])]);
      }), 128))], 512), _createElementVNode("div", _hoisted_115, [false ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: _ctx.scrollToTop,
        style: {
          "height": "35px"
        },
        class: "green-plain",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("Scroll Top")];
        }),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        onClick: _ctx.cancelDetailedCashfloat,
        style: {
          "height": "35px"
        },
        class: "green-plain"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: _ctx.confirmDetailedCashfloat,
        style: {
          "height": "35px"
        },
        class: "green-plain",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])])])];
    }),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true)], 64);
}